module.exports = __webpack_public_path__ + "92ecf73cfd2f74f522bd16bc238ecafe.fbx";